import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@ant-design/v5-patch-for-react-19';
import 'azure-maps-control/dist/atlas.min.css';
import mixpanel from 'mixpanel-browser';
import ChunkErrorBoundary from './components/error/ChunkErrorBoundary';
import { tryRecoverFromChunkError } from './utils/chunkError';

const root = document.getElementById('root');
const reactRoot = createRoot(root);

// MixPanel
if (process.env.NODE_ENV === 'production') {
    mixpanel.init("abdd8985491168e133c456a1fae4d2bf", {
        debug: false,
        track_pageview: true,
        persistence: "localStorage",
        record_sessions_percent: 1, //records 1% of all sessions
        record_heatmap_data: true,
    });
}

window.addEventListener('error', (event) => {
    tryRecoverFromChunkError(event?.error || event?.message);
});

window.addEventListener('unhandledrejection', (event) => {
    tryRecoverFromChunkError(event?.reason);
});

reactRoot.render(
    //<React.StrictMode>
        <ChunkErrorBoundary>
            <App />
        </ChunkErrorBoundary>
    //</React.StrictMode>
);
